module.exports = __webpack_public_path__ + "img/p_22.6cf4e7cf.png";